import { KSpan } from "kahuna-base-react-components"
import React from "react"
import { Track } from "../../../../types"
import AudioPlayer from "../track-detail/AudioPlayer"
import { avatarColorList, avatarFontColorList, getRandomAvatarIndex } from "../../../../constants"
import { lang } from "../../../../constants/languages"

const ReleaseDetailListComponent = ({
  i,
  row,
  playingAudioRefs,
  setPlayingAudioRefs,
  setSelectedTrack
}: {
  i: number
  row: Track
  playingAudioRefs: HTMLAudioElement[]
  setPlayingAudioRefs: (playingAudioRefs: HTMLAudioElement[]) => void
  setSelectedTrack: (selectedTrack: number | undefined) => void
}) => {
  const divHeight = 72

  const formatNumber = (index: number) => {
    return index ? index.toString().padStart(2, "0") : ""
  }

  const getInitials = (input: string): string => {
    const filteredInput = input || "-"
    return filteredInput
      .split(",")
      .map((name) => name.trim()[0].toUpperCase())
      .join("")
  }

  return (
    <li
      className={`rounded-[10px] p-[20px] gap-[20px] h-[${divHeight}] table-row-hover hover:bg-[#F7F7F7] !border-none cursor-pointer`}
      key={`data-row-${i}`}
      onClick={() => setSelectedTrack(row.id)}
    >
      <div className={`flex flex-row items-center gap-1.5`} style={{ width: "100%" }}>
        <div style={{ width: "5%" }}>
          <KSpan text={formatNumber(i + 1)} lineHeight="20px" fontSize={14} fontWeight={500} color="#737373" />
        </div>

        <div style={{ width: "5%" }}>
          <AudioPlayer
            src={row.audioFileUrl}
            playingAudioRefs={playingAudioRefs}
            setPlayingAudioRefs={setPlayingAudioRefs}
          />
        </div>

        <div className="flex items-center justify-start" style={{ width: "35%" }}>
          <KSpan text={row.title} fontWeight={400} color="#111" fontSize={14} />
        </div>

        <div className="flex items-center justify-start pl-1.5" style={{ width: "15%" }}>
          <div className="flex">
            {row.shareHolders?.map((shareHolder) => {
              const randomIndex = getRandomAvatarIndex(shareHolder.id)
              return (
                <div
                  key={shareHolder.id}
                  className="w-6 h-6 rounded-[16px] flex justify-center items-center"
                  style={{
                    fontWeight: "500",
                    backgroundColor: avatarColorList[randomIndex],
                    color: avatarFontColorList[randomIndex],
                    marginLeft: -6
                  }}
                >
                  {getInitials(shareHolder.userName)}
                </div>
              )
            })}
          </div>
        </div>

        <div className="flex items-center justify-start" style={{ width: "20%" }}>
          <KSpan
            text={row.shareData ? `${row.shareData.share}%` : "0%"}
            fontWeight={500}
            color="#111"
            fontSize={12}
            lineHeight="16px"
          />
        </div>

        <div className="flex items-center justify-start" style={{ width: "20%" }}>
          <KSpan
            text={row.shareData && row.shareData.roles.length > 0 ? row.shareData.roles.join(", ") : "-"}
            fontWeight={500}
            color="#111"
            fontSize={12}
            lineHeight="16px"
          />
        </div>
      </div>
    </li>
  )
}

export default ReleaseDetailListComponent
